const proxiableDevices = ["Puck", "FlowieO", "FlowieU", "Shuttie", "Shuttie2"]
export default proxiableDevices;